<ng-container>
  <div class="history-wrapper">
    <mat-sidenav-container #matContainer class="order-filter-sidepanel">
      <!-- START SIDE NAV CONTAINER -->
      <mat-sidenav #sidenav (closed)="onClose(0)" [mode]="mode.value" [(opened)]="sideNavOpened">
        <div class="close-icon">
          <mat-icon (click)="sidenav.close()" class="material-icons-sharp md-12">clear</mat-icon>
        </div>

        <div class="order-history-sort-side" *ngIf="this.selectedFilter === 0">
          <p class="sort-label">{{ 'orders.sortSideLabel' | cxTranslate }}</p>
          <hr />
          <app-sorting
            *ngIf="this.orderView === 'orders'"
            [sortOptions]="filterSortOptions(sortOptions)"
            [sortLabels]="sortLabels | async"
            (sortListEvent)="sortChange($event)"
            [selectedOption]="sort"
          >
          </app-sorting>
          <app-sorting
            *ngIf="this.orderView === 'backorder'"
            [sortOptions]="filterBackorderSortOptions(bsortOptions, showExpectedShipmentDate$ | async)"
            [sortLabels]="sortLabels | async"
            (sortListEvent)="sortChange($event)"
            [selectedOption]="sort"
          >
          </app-sorting>
          <app-sorting
            *ngIf="this.orderView === 'invoice'"
            [sortOptions]="filterInvoiceOptions(invoiceSortOptions)"
            [sortLabels]="invoiceSortLabels | async"
            (sortListEvent)="sortChange($event)"
            [selectedOption]="invoiceSort"
          >
          </app-sorting>
        </div>
        <div class="order-history-filter-side" [ngStyle]="{ 'margin-top': this.selectedFilter === 0 ? '16px' : '0' }">
          <app-order-history-filter></app-order-history-filter>
        </div>
      </mat-sidenav>
      <!-- END SIDE NAV CONTAINER -->

      <!-- START BODY CONTAINER -->
      <mat-sidenav-content class="order-history-body-content">
        @switch (this.orderView) { @case ('invoice') {
        <app-order-history-invoice
          [currentPayload]="orderHistoryPayload"
          (toggleSidenavEvent)="toggleSidenav()"
          (updateSortSelectedOptionEvent)="updateSortSelectedOption($event)"
        ></app-order-history-invoice>
        } @default {
        <!-- FOR RESULTS-->
        <ng-container *ngIf="!resultsSpinner; else showSpinner">
          <div class="filter-container">
            <!-- FOR SORT DISPLAY-->
            <div class="order-history-sort" *ngIf="!showNoResult">
              <app-sorting
                [sortOptions]="
                  this.orderView === 'backorder'
                    ? filterBackorderSortOptions(bsortOptions, showExpectedShipmentDate$ | async)
                    : filterSortOptions(sortOptions)
                "
                [sortLabels]="sortLabels | async"
                (sortListEvent)="sortChange($event)"
                [selectedOption]="sort"
              >
              </app-sorting>
            </div>
            <!-- FOR SORT & FILTER - TABLET AND MOBILE ONLY-->
            <div class="filter-wrapper">
              <button class="btn-sort-filter" (click)="toggleSidenav()">
                <mat-icon class="light" svgIcon="filter"></mat-icon>
                {{ 'orders.sortFilter' | cxTranslate }}
              </button>
            </div>
            <!-- EXPORT CSV -->
            <div class="export-file">
              @if (features?.downloadOpenOrders) {
              <button class="tertiary-btn" (click)="downloadOpenOrders()">
                <mat-icon class="light" svgIcon="exportfile"></mat-icon
                ><span>{{ 'orders.downloadOpenOrders' | cxTranslate }}</span>
              </button>
              } @else if (features?.showExportCsv && !showNoResult) {
              <button class="tertiary-btn" (click)="exportCsv()">
                <mat-icon class="light" svgIcon="exportfile"></mat-icon
                ><span>{{ 'orders.exportCsv' | cxTranslate }}</span>
              </button>
              }
            </div>
          </div>

          <!-- FOR ORDER RESULTS-->
          <ng-container *ngIf="this.orderView === 'orders' && orderHistoryResults">
            <ng-container *ngIf="orderHistoryResults.length > 0">
              <div class="order-history-wrapper">
                <div class="order-history-content" *ngFor="let orders of orderHistoryResults">
                  <a
                    tabindex="0"
                    [routerLink]="
                      {
                        cxRoute: 'orderDetails',
                        params: orders
                      } | cxUrl
                    "
                    [queryParams]="orders?.erpOrderType ? { erpOrderType: orders?.erpOrderType } : {}"
                  >
                    <div class="order-history-details">
                      <div class="status tablet-status">
                        <mat-icon
                          [svgIcon]="getStatusIcon(orders?.statusCode)"
                          class="mat-icon"
                          [matTooltip]="getStatusTooltip(orders?.statusCode) | async"
                          [matTooltipPosition]="'below'"
                          matTooltipClass="icon-tooltip"
                          [attr.aria-label]="orders?.statusDisplay"
                        ></mat-icon>
                      </div>
                      <div class="data">
                        <div class="order-number">
                          <span class="label">{{ 'orders.orderNumber' | cxTranslate }}</span>
                          <span class="value">{{ orders?.erpOrderNumber }}</span>
                        </div>
                        <div class="po-number">
                          <span class="label">{{ 'orders.poNumber' | cxTranslate }}</span>
                          <span class="value">
                            <app-tooltip-text
                              class="orders-po-number-truncate"
                              [tooltipContent]="orders?.purchaseOrderNumber"
                              [content]="orders?.purchaseOrderNumber"
                              placement="bottom"
                            >
                            </app-tooltip-text>
                          </span>
                        </div>

                        <div class="date-placed">
                          <span class="label">{{ 'orders.datePlaced' | cxTranslate }}</span>
                          <span class="value">{{ orders?.createdDateString | date : dateFormatted }}</span>
                        </div>
                        <div class="request-date" *ngIf="features?.showOrderRequestDate">
                          <span class="label">{{ 'orders.dateRequest' | cxTranslate }}</span>
                          <span class="value">{{ orders?.dateRequestString | date : dateFormatted }}</span>
                        </div>
                        <div class="order-by">
                          <span class="label">{{ 'orders.orderBy' | cxTranslate }}</span>
                          <app-tooltip-text
                            class="value"
                            [tooltipContent]="orders?.placedBy"
                            [content]="orders?.placedBy"
                            placement="bottom"
                          >
                          </app-tooltip-text>
                        </div>

                        <div class="total-amount" [class.mb-xl-2]="showGstInclusive$ | async">
                          <span class="label" *ngIf="!showSrp">{{ 'orders.totalAmount' | cxTranslate }}</span>
                          <span class="label" *ngIf="showSrp" [style.width.px]="89">&nbsp;</span>
                          <span class="value" *ngIf="!showSrp"
                            >{{ orders?.totalPrice?.formattedValue
                            }}<span
                              *ngIf="orders?.totalPrice?.formattedValue && showGstInclusive$ | async"
                              class="gst-label"
                              >{{ 'gst.inclusive' | cxTranslate }}</span
                            ></span
                          >
                        </div>
                        <div class="order-type">
                          <span class="label">{{ 'orders.orderType' | cxTranslate }}</span>
                          <span class="value">{{ orders?.orderType }}</span>
                        </div>
                        <div
                          class="shipping-address"
                          [ngClass]="activeCountry$ | async"
                          [class.fixed-height]="orders?.deliveryFee && !(isMobile$ | async)"
                          [class.has-hold-status]="features.showHoldStatus"
                        >
                          <span class="label">{{ 'orders.shippingAddress' | cxTranslate }}</span>
                          <span class="value" *ngIf="showAddress(orders?.deliveryAddress) | async as address">
                            <app-tooltip-text
                              class="orders-shipping-address-truncate"
                              [tooltipContent]="address"
                              [content]="address"
                              placement="bottom"
                            >
                            </app-tooltip-text>
                          </span>
                        </div>
                        <div class="delivery-fee" *ngIf="orders?.deliveryFee && showDeliveryFee$ | async">
                          <span class="label">{{
                            'myAccount.orderDetails.orderTotalSummary.deliveryFee' | cxTranslate
                          }}</span>
                          <span class="value">{{ orders?.deliveryFee | mycurrency }}</span>
                        </div>
                        <div class="hold-status" *ngIf="features.showHoldStatus">
                          <span class="label">{{ 'orders.holdStatus' | cxTranslate }}</span>
                          <span class="value">
                            <app-tooltip-text
                              class="orders-hold-status-truncate"
                              [tooltipContent]="orders?.holdCode"
                              [content]="orders?.holdCode"
                              placement="bottom"
                            >
                            </app-tooltip-text>
                          </span>
                        </div>
                      </div>
                    </div>
                  </a>
                  <div class="cta-wrapper">
                    <div class="order-history-link">
                      <a
                        tabindex="0"
                        [routerLink]="{ cxRoute: 'orderDetails', params: orders } | cxUrl"
                        [queryParams]="orders?.erpOrderType ? { erpOrderType: orders?.erpOrderType } : {}"
                      >
                        <mat-icon
                          matTooltip="{{ 'buttonTooltip.orderHistory.orderDetailsButton' | cxTranslate }}"
                          [matTooltipPosition]="'below'"
                          matTooltipClass="icon-tooltip"
                          aria-label="displays a tooltip in bottom"
                          class="material-icons-sharp light mat-icon"
                          [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
                          >assignment</mat-icon
                        >
                      </a>
                    </div>
                    <app-reorder
                      *ngIf="orders.orderTypeCode === 'SO' || orders.orderTypeCode === 'PO'"
                      [code]="orders.erpOrderNumber"
                      [orderDetails]="orders"
                      [erpOrderType]="orders?.erpOrderType"
                    ></app-reorder>
                  </div>
                </div>
                <div
                  infiniteScroll
                  [infiniteScrollDistance]="2"
                  [infiniteScrollThrottle]="1000"
                  (scrolled)="onScroll()"
                ></div>
                <mat-spinner *ngIf="!isGetOrdersBackOrdersDone" [diameter]="72"></mat-spinner>
                <p class="text-center mt-4" *ngIf="features.showMaxResultsText && isGetOrdersBackOrdersDone">
                  {{ 'orders.maxResults' | cxTranslate : { resultsCount: PaginationModel?.totalResults } }}
                </p>
              </div>
            </ng-container>
          </ng-container>

          <!-- FOR BACKORDDER RESULTS-->
          <ng-container *ngIf="this.orderView === 'backorder' && orderHistoryResults">
            <ng-container *ngIf="orderHistoryResults.length > 0">
              <div class="backorder-wrapper" [class.wide-div]="features?.showBackorderRequestDate">
                <div
                  [ngClass]="activeLanguage$ | async"
                  class="backorder-content"
                  *ngFor="let backorder of orderHistoryResults"
                >
                  <div class="backorder-icon-wrapper">
                    <div class="status tablet-status">
                      <span><mat-icon svgIcon="back-order" title="Back Order" class="mat-icon"></mat-icon></span>
                    </div>
                  </div>
                  <div class="backorder-products">
                    <div class="product-details">
                      <ng-container *ngFor="let image of backorder?.product?.images">
                        <cx-media
                          class="cx-product-image"
                          [container]="getImageRendition(image)"
                          [class.is-missing-fish]="businessType === 'fish'"
                        ></cx-media>
                      </ng-container>
                      <cx-media
                        *ngIf="backorder?.product?.images === undefined || backorder?.product?.images === null"
                        class="cx-no-image is-missing"
                        [class.is-missing-fish]="businessType === 'fish'"
                      ></cx-media>
                      <div class="product-info">
                        <p *ngIf="features?.showExportCsv" class="label">{{ 'orders.item' | cxTranslate }}</p>
                        <p class="item-number" [class.black-text]="features?.showExportCsv">
                          {{ backorder?.product?.code }}
                        </p>
                        <p class="product-description" *ngIf="backorder?.product?.name">
                          {{ backorder?.product?.name }}
                        </p>
                        <div class="global-variant" *ngIf="backorder?.product?.superCategories">
                          <ng-container
                            *ngFor="
                              let variant of checkVariant(backorder?.product?.superCategories);
                              let index = index;
                              let last = last
                            "
                          >
                            <ng-container *ngIf="!last; else lastItem"
                              >{{ variant.parentCategoryName }}: {{ variant.name }};
                            </ng-container>
                            <ng-template #lastItem>{{ variant.parentCategoryName }}: {{ variant.name }}</ng-template>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                    <div class="product-more-info">
                      <div class="order-number">
                        <p class="label">{{ 'orders.orderNumber' | cxTranslate }}</p>
                        <p class="data">{{ backorder?.erpOrderNumber }}</p>
                      </div>
                      <div class="date-placed">
                        <p class="label">{{ 'orders.datePlaced' | cxTranslate }}</p>
                        <p class="data">{{ backorder?.orderDate | date : dateFormatted }}</p>
                      </div>
                      <div class="request-date" *ngIf="features?.showBackorderRequestDate">
                        <p class="label">{{ 'orders.dateRequest' | cxTranslate }}</p>
                        <p class="data">{{ backorder?.dateRequest | date : dateFormatted }}</p>
                      </div>
                      <div class="delivery-date" *ngIf="showExpectedShipmentDate$ | async">
                        <p class="label">{{ 'orders.deliveryDate' | cxTranslate }}</p>
                        <p class="data">{{ backorder?.deliveryDate | date : dateFormatted }}</p>
                      </div>
                      <div class="dealer-price">
                        <p class="label" *ngIf="!showSrp">{{ 'orders.dealerPrice' | cxTranslate }}</p>
                        <p class="label" *ngIf="showSrp" [style.width.px]="79">&nbsp;</p>
                        <p class="data" *ngIf="!showSrp">
                          {{ backorder?.basePrice?.formattedValue
                          }}<span
                            *ngIf="backorder?.basePrice?.formattedValue && showGstInclusive$ | async"
                            class="gst-label"
                            >{{ 'gst.exclusive' | cxTranslate }}</span
                          >
                        </p>
                      </div>
                      <div class="quantity">
                        <p class="label">{{ 'orders.quantity' | cxTranslate }}</p>
                        <p class="data">{{ backorder?.quantity }}</p>
                      </div>
                      <div class="total-amount">
                        <p class="label" *ngIf="!showSrp">{{ 'orders.totalAmount' | cxTranslate }}</p>
                        <p class="label" *ngIf="showSrp" [style.width.px]="89">&nbsp;</p>
                        <p class="data" *ngIf="showSrp" [style.width.px]="89">&nbsp;</p>
                        <p class="data" *ngIf="!showSrp">
                          {{ backorder?.totalPrice?.formattedValue
                          }}<span
                            *ngIf="backorder?.totalPrice?.formattedValue && showGstInclusive$ | async"
                            class="gst-label"
                            >{{ 'gst.exclusive' | cxTranslate }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  infiniteScroll
                  [infiniteScrollDistance]="2"
                  [infiniteScrollThrottle]="1000"
                  (scrolled)="onScroll()"
                ></div>
                <mat-spinner *ngIf="!isGetOrdersBackOrdersDone" [diameter]="72"></mat-spinner>
                <p class="text-center mt-4" *ngIf="features.showMaxResultsText && isGetOrdersBackOrdersDone">
                  {{ 'orders.maxResults' | cxTranslate : { resultsCount: PaginationModel?.totalResults } }}
                </p>
              </div>
            </ng-container>
          </ng-container>

          <!-- FOR NO RESULT-->
          <ng-container *ngIf="showNoResult">
            <div class="no-results">
              <p>{{ 'orders.noResultsFound' | cxTranslate }}</p>
            </div>
          </ng-container>
        </ng-container>

        <!-- FOR RESULT SPINNER-->
        <ng-template #showSpinner>
          <div class="results-spinner">
            <mat-spinner [diameter]="72"></mat-spinner>
          </div>
        </ng-template>
        } }
      </mat-sidenav-content>
      <!-- END BODY CONTAINER -->
    </mat-sidenav-container>
  </div>
</ng-container>
